import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import FloatingWhatsApp from '@/components/FloatingWhatsApp';
import { Button } from "@/components/ui/button";
import { ArrowRight, Phone, FileText, Rocket, PlayCircle, TrendingUp } from "lucide-react";
import { Link } from 'react-router-dom';
const Process = () => {
  const steps = [{
    number: 1,
    icon: <Phone className="w-8 h-8" />,
    title: "Αρχική Επικοινωνία",
    description: "Κλείνεις μια σύντομη κλήση μαζί μας για να καταλάβουμε τι θέλεις να πετύχεις, τι υπάρχει ήδη και πού θες να φτάσεις.",
    duration: "15-30 λεπτά"
  }, {
    number: 2,
    icon: <FileText className="w-8 h-8" />,
    title: "Ανάλυση & Πρόταση",
    description: "Σου παρουσιάζουμε μια απλή πρόταση με βήματα, χρονοδιάγραμμα και τιμή — χωρίς περιττές θεωρίες ή \"πακέτα\".",
    duration: "1-2 εργάσιμες μέρες"
  }, {
    number: 3,
    icon: <Rocket className="w-8 h-8" />,
    title: "Υλοποίηση",
    description: "Αναλαμβάνουμε το στήσιμο του funnel, τις σελίδες, τα VSLs, το περιεχόμενο, τη διαφήμιση ή τα προιόντα ανάλογα με αυτό που συμφωνήσαμε.",
    duration: "1-4 εβδομάδες"
  }, {
    number: 4,
    icon: <PlayCircle className="w-8 h-8" />,
    title: "Λειτουργία & Δοκιμή",
    description: "Το σύστημα μπαίνει live και ξεκινάμε τα πρώτα tests. Βλέπουμε τα αποτελέσματα, μετράμε, διορθώνουμε.",
    duration: "Συνεχής"
  }, {
    number: 5,
    icon: <TrendingUp className="w-8 h-8" />,
    title: "Scaling & Υποστήριξη",
    description: "Αν θέλεις, συνεχίζουμε μαζί για να εξελίξουμε το σύστημα, να προσθέσουμε νέα κανάλια, να κάνουμε scale ή να μετατρέψουμε την εμπειρία σου σε digital asset.",
    duration: "Μακροπρόθεσμα"
  }];
  return <>
      <Navbar />
      <main className="min-h-screen bg-black">
        {/* Hero Section */}
        <section className="pt-32 pb-16">
          <div className="container mx-auto px-6 md:px-8 lg:px-12">
            <div className="max-w-4xl mx-auto text-center mb-20">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-8 animate-fade-in-up">
                Πώς δουλεύουμε με νέες επιχειρήσεις
              </h1>
              
              <p className="text-xl md:text-2xl text-gray-300 mb-8 animate-fade-in-up" style={{
              animationDelay: '0.1s'
            }}>
                Έχουμε ξεκάθαρη διαδικασία. Χωρίς μπέρδεμα. Χωρίς χάσιμο χρόνου.
              </p>
              
              <p className="text-lg text-gray-400 animate-fade-in-up" style={{
              animationDelay: '0.2s'
            }}>
                Αν έχεις ιδέα ή brand, μπορούμε να τη μετατρέψουμε σε online πωλήσεις.
              </p>
            </div>
          </div>
        </section>

        {/* Process Steps */}
        <section className="py-16 bg-dark-200">
          <div className="container mx-auto px-6 md:px-8 lg:px-12">
            <div className="max-w-5xl mx-auto">
              <div className="grid gap-8 md:gap-12">
                {steps.map((step, index) => <div key={step.number} className="animate-fade-in-up premium-card" style={{
                animationDelay: `${0.1 + index * 0.1}s`
              }}>
                    <div className="grid md:grid-cols-12 gap-6 items-center p-8 md:p-10">
                      {/* Step Number & Icon */}
                      <div className="md:col-span-2 flex flex-col items-center">
                        <div className="w-20 h-20 rounded-full bg-gradient-to-br from-brand to-brand/80 flex items-center justify-center text-white text-2xl font-bold mb-4 shadow-lg">
                          {step.number}
                        </div>
                        <div className="text-brand">
                          {step.icon}
                        </div>
                      </div>
                      
                      {/* Content */}
                      <div className="md:col-span-8">
                        <h3 className="text-2xl md:text-3xl font-bold text-white mb-4">
                          {step.title}
                        </h3>
                        <p className="text-gray-300 text-lg leading-relaxed mb-4">
                          {step.description}
                        </p>
                        <div className="inline-flex items-center px-4 py-2 bg-brand/10 border border-brand/20 rounded-full">
                          <span className="text-brand text-sm font-medium">
                            ⏱ {step.duration}
                          </span>
                        </div>
                      </div>
                      
                      {/* Connection Line */}
                      {index < steps.length - 1 && <div className="md:col-span-2 hidden md:flex justify-center">
                          <div className="w-1 h-16 bg-gradient-to-b from-brand/50 to-transparent"></div>
                        </div>}
                    </div>
                  </div>)}
              </div>
            </div>
          </div>
        </section>

        {/* Benefits Section */}
        <section className="py-16">
          <div className="container mx-auto px-6 md:px-8 lg:px-12">
            <div className="max-w-4xl mx-auto text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 animate-fade-in-up">
                Γιατί να επιλέξεις τη διαδικασία μας;
              </h2>
              
              <div className="grid md:grid-cols-3 gap-8 mt-12">
                <div className="text-center animate-fade-in-up" style={{
                animationDelay: '0.1s'
              }}>
                  <div className="w-16 h-16 rounded-full bg-brand/10 flex items-center justify-center mx-auto mb-4">
                    <span className="text-2xl">⚡</span>
                  </div>
                  <h3 className="text-xl font-bold text-white mb-2">Ταχύτητα</h3>
                  <p className="text-gray-300">Γρήγορη υλοποίηση χωρίς περιττές καθυστερήσεις</p>
                </div>
                
                <div className="text-center animate-fade-in-up" style={{
                animationDelay: '0.2s'
              }}>
                  <div className="w-16 h-16 rounded-full bg-brand/10 flex items-center justify-center mx-auto mb-4">
                    <span className="text-2xl">🎯</span>
                  </div>
                  <h3 className="text-xl font-bold text-white mb-2">Στόχευση</h3>
                  <p className="text-gray-300">Εστιάζουμε στα αποτελέσματα, όχι στις θεωρίες</p>
                </div>
                
                <div className="text-center animate-fade-in-up" style={{
                animationDelay: '0.3s'
              }}>
                  <div className="w-16 h-16 rounded-full bg-brand/10 flex items-center justify-center mx-auto mb-4">
                    <span className="text-2xl">🤝</span>
                  </div>
                  <h3 className="text-xl font-bold text-white mb-2">Συνεργασία</h3>
                  <p className="text-gray-300">Δουλεύουμε μαζί σου, όχι για σένα</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-dark-200">
          <div className="container mx-auto px-6 md:px-8 lg:px-12">
            <div className="max-w-3xl mx-auto text-center">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 animate-fade-in-up">
                Έτοιμος να ξεκινήσεις;
              </h2>
              <p className="text-xl text-gray-300 mb-8 animate-fade-in-up" style={{
              animationDelay: '0.1s'
            }}>
                Κλείσε μια κλήση για να δούμε πώς μπορούμε να βοηθήσουμε την επιχείρησή σου να αναπτυχθεί.
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-in-up" style={{
              animationDelay: '0.2s'
            }}>
                <Button asChild className="bg-brand hover:bg-brand-hover text-white font-medium text-lg px-12 py-6" size="lg">
                  <Link to="/contact">
                    Ξεκίνα τη διαδικασία <ArrowRight className="ml-2" />
                  </Link>
                </Button>
                
                <Button variant="outline" asChild className="border-gray-600 text-white hover:bg-gray-800 font-medium text-lg px-12 py-6" size="lg">
                  
                </Button>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <FloatingWhatsApp />
    </>;
};
export default Process;